module.exports = __webpack_public_path__ + "static/ss10.f7d1361c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo/ss10.png
// module id = 526
// module chunks = 35783957827783